import { Component, OnInit } from '@angular/core';
import { FcmService } from '../../services/FCM/fcm.service';
import { SwPush } from '@angular/service-worker';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  showBanner = true;
  isRequesting = false;
  isAppleDevice = false;
  notificationsSupported = false;
  pushSupported = false;

  constructor(public fcmService: FcmService,private swPush: SwPush) {}

  ngOnInit(): void {
    this.detectDeviceCapabilities();
    
    if (Notification.permission === 'granted') {
      this.showBanner = false;
      this.getTokenSilently();
    } else {
      const bannerDismissed = localStorage.getItem('notificationBannerDismissed');
      this.showBanner = bannerDismissed !== 'true';
    }
  }
  private detectDeviceCapabilities() {
    this.isAppleDevice = /(iPhone|iPad|iPod|Macintosh)/i.test(navigator.userAgent) && 
                        /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // alert('PushManager' in window)
    this.notificationsSupported = 'Notification' in window;
    this.pushSupported = 'PushManager' in window;

    if (!this.notificationsSupported) {
      console.log('Notifications are NOT supported on this device/browser.');
      // Hide banner or show alternative text
      // this.showBanner = false;
    }
  }
  // private detectDeviceCapabilities() {
  //   // Detect Apple devices (iOS, iPadOS, macOS)
  //   this.isAppleDevice = /(iPhone|iPad|iPod|Macintosh)/i.test(navigator.userAgent) && 
  //                       /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  //   // Check notification support
  //   this.notificationsSupported = 'Notification' in window;
  //   this.pushSupported = 'PushManager' in window;

  //   if (this.isAppleDevice) {
  //     console.log('Apple device detected - using limited notification capabilities');
  //     // Apple devices have limited support, so we'll adjust our approach
  //   }
  // }

  async enableNotifications() {
    if (this.fcmService.checkIfPermissionBlocked()) {
      this.showPermissionBlockedMessage();
      return;
    }

    if (this.isAppleDevice) {
      await this.handleAppleNotifications();
    } else {
      await this.handleAndroidNotifications();
    }
  }

  private async handleAppleNotifications() {
    this.isRequesting = true;

    // Check if running in standalone mode (added to home screen)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                        (window.navigator as any).standalone ||
                        document.referrer.includes('android-app://');
    // alert(isStandalone)

    // Only show the alert if in browser mode and not standalone
    if (!isStandalone && !this.isBrowser()) {
      const userAction = confirm(
        '🚫 Notifications work best when added to your Home Screen.\n\n' +
        'On iPhone, please:\n' +
        '1. Open in Safari\n' +
        '2. Tap the share button\n' +
        '3. Select "Add to Home Screen"\n\n'
      );

      if (!userAction) {
        this.isRequesting = false;
        return;
      }
    }
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("../../../sw.js").then(reg => {
        alert("✅ Service Worker registered"+ reg);
      });
    }
    try {
      // Check if service worker push is available
      if (this.swPush.isEnabled) {
        const subscription = await this.swPush.requestSubscription({
          serverPublicKey: 'BBCCp_Rmc6BTNovECVUFYlw86L6WgmJucuOPPxhwHn4iDIdlSpUwD_5mFq7KX0P0Zob39FlSlFsS_BxjOcBvT0k'
        });
        
        console.log('Push subscription:', subscription);
        // Send to backend: this.yourBackendService.saveSubscription(subscription);
      }

      // Request notification permission
      const permission = await Notification.requestPermission();

      if (permission !== 'granted') {
        console.warn('User denied notification permission on Apple device');
        return;
      }

      // Get FCM token
      const token = await this.fcmService.getToken();
      if (token) {
        this.showBanner = false;
        this.handleSuccessfulPermission(token);
      }
    } catch (error) {
      console.error('Apple notification request failed:', error);
    } finally {
      this.isRequesting = false;
    }
  }

  // Helper method to check if running in a browser
  private isBrowser(): boolean {
    return !('standalone' in window.navigator) && 
          window.navigator.userAgent.indexOf('Safari') !== -1;
  }



  private async handleAndroidNotifications() {
    this.isRequesting = true;
    try {
      const permission = await this.fcmService.requestPermission();
      if (permission === 'granted') {
        const token = await this.fcmService.getToken();
        this.showBanner = false;
        if (token) {
          this.handleSuccessfulPermission(token);
        }
      }
    } finally {
      this.isRequesting = false;
    }
  }

  private isSafari(): boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  private showPermissionBlockedMessage() {
    this.showBanner = true;
  }

  private handleSuccessfulPermission(token: string) {
    console.log('FCM Token:', token);
    this.showBanner = false;
    localStorage.setItem('FCM_Token', token);
    localStorage.removeItem('notifications_blocked');
  }

  private async getTokenSilently() {
    if (this.isAppleDevice) return; // Skip for Apple devices
    
    try {
      const token = await this.fcmService.getToken();
      if (token && !localStorage.getItem('FCM_Token')) {
        localStorage.setItem('FCM_Token', token);
      }
    } catch (error) {
      console.error('Error getting FCM token:', error);
    }
  }

  dismissBanner() {
    this.showBanner = false;
    localStorage.setItem('notificationBannerDismissed', 'true');
  }

  isPermissionBlocked(): boolean {
    return this.fcmService.checkIfPermissionBlocked();
  }

  reloadPage() {
    window.location.reload();
  }
}